import { ObtenerTablaPresuntivaPrestamoImpresionMS } from './../../../open-api/model/obtenerTablaPresuntivaPrestamoImpresionMS';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla-presuntiva',
  templateUrl: './tabla-presuntiva.component.html',
  styleUrls: ['./tabla-presuntiva.component.scss']
})
export class TablaPresuntivaComponent implements OnInit {

  @Input() tablaPresuntiva?: ObtenerTablaPresuntivaPrestamoImpresionMS;

  constructor() { }

  ngOnInit(): void {
  }

}
